import { Globe } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconGlobe(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Globe />
    </IconWrapper>
  );
}
